export function formatWithPlaceholders(template, replacements = {}) {
  if (typeof template !== 'string') {
    return template;
  }

  return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) => {
    const value = replacements[key];
    return value === undefined || value === null ? '' : String(value);
  });
}
